import { render, staticRenderFns } from "./PassThrough.vue?vue&type=template&id=966f5984&scoped=true&lang=html"
import script from "./PassThrough.vue?vue&type=script&lang=js"
export * from "./PassThrough.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "966f5984",
  null
  
)

export default component.exports